/* eslint-disable react/prop-types */
import React from 'react';
import './index.less';

export default function ModernButton({ text, icon, style, className = '', disabled, onClick }) {

  return(
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      style={style}
      className={`modern-button ${className} ${!text ? 'icon-only' : ''} ${disabled ? 'disabled' : ''}`}
    >
      {icon}
      {text}
    </button>
  );
}